import axios from "@/axios";
import apiUrl from "@/axios/config";

const accountInfo = {
  upImg(params) {
    //图片上传
    return jQuery.ajax({
      type: "post",
      data: params,
      xhrFields: { withCredentials: true },
      crossDomain: true,
      processData: false,
      contentType: false,
      dataType: "json",
      url: apiUrl.API_BASE_URL + "uc/user/userinfo/identityinfoimg"
    });
  },
  upImg2(params) {
    //图片上传
    return jQuery.ajax({
      type: "post",
      data: params,
      xhrFields: { withCredentials: true },
      crossDomain: true,
      processData: false,
      contentType: false,
      dataType: "json",
      url: apiUrl.API_BASE_URL + "uc/upload/images"
    });
  },
  upImg3(params) {
    //银行卡图片上传
    return jQuery.ajax({
      type: "post",
      data: params,
      xhrFields: { withCredentials: true },
      crossDomain: true,
      processData: false,
      contentType: false,
      dataType: "json",
      url: apiUrl.API_BASE_URL + "uc/user/bank/userbankimg"
    });
  },
  async submit(params) {
    //图片上传提交按钮
    return await axios.post("/uc/user/userinfo/identityInfoSubmit", params, {
      des: "直客wap图片上传提交",
      sTime: new Date().getTime()
    });
  },

  async bankName(params) {
    //根据银行卡号前六位获取银行名称
    return await axios.get(
      "/uc/bank/matchingBank",
      { params },
      {
        des: "直客wap根据银行卡号前六位获取银行名称",
        sTime: new Date().getTime()
      }
    );
  },
  async addbankcard(params) {
    //银行卡资料新增
    return await axios.post("/uc/user/bank/add", params, {
      des: "直客wap银行卡资料新增",
      sTime: new Date().getTime()
    });
  },
  async updatebankcard(params) {
    //银行卡资料更新
    return await axios.post("/uc/user/bank/update", params, {
      des: "直客wap银行卡资料更新",
      sTime: new Date().getTime()
    });
  },
  async bankList(params) {
    //银行资料列表
    return await axios.post("/uc/user/bank/list", params, {
      des: "直客wap银行资料列表",
      sTime: new Date().getTime()
    });
  },
  async cardDetail(params) {
    //银行卡详情
    return await axios.post("/uc/user/bank/detail", params, {
      des: "直客wap银行卡详情",
      sTime: new Date().getTime()
    });
  },
  async bankSwitch(params) {
    //四要素开关
    return await axios.get(
      "/uc/user/bank/bankSwitch",
      { params },
      { des: "四要素开关", sTime: new Date().getTime() }
    );
  },
  async cancelBindCard(params) {
    //取消绑定银行卡
    return await axios.post("/uc/user/bank/removebind", params, {
      des: "直客wap取消绑定银行卡",
      sTime: new Date().getTime()
    });
  },
  async sendPhoneCode(params) {
    //发送验证码
    return await axios.post("/uc/sendcode2", params, {
      des: "直客wap发送验证码",
      sTime: new Date().getTime()
    });
  },
  async changePwd(params) {
    //修改密码
    return await axios.post("/uc/user/password/modify", params, {
      des: "直客wap改密码",
      sTime: new Date().getTime()
    });
  },
  async userPositions(params) {
    //持仓明细
    return await axios.get(
      "/uc/api/transaction/userPositions",
      { params },
      { des: "直客wap获取持仓明细", sTime: new Date().getTime() }
    );
  },
  async userClosePositions(params) {
    //平仓明细
    return await axios.get(
      "/uc/api/transaction/userClosePositions",
      { params },
      { des: "直客wap获取平仓明细", sTime: new Date().getTime() }
    );
  },
  async getUserInfos(params) {
    //用户信息详情
    return await axios.post("/uc/user/userinfo/info", params, {
      des: "直客wap获取用户信息详情",
      sTime: new Date().getTime()
    });
  },
  //获取账户资料基本信息
  async getIdentityInfo(params = "") {
    return await axios.post("/uc/user/userinfo/identityInfo", params, {
      des: "直客wap获取账户资料基本信息",
      sTime: new Date().getTime()
    });
  },
  //新版实名认证接口
  async submitInfo(params) {
    return await axios.post("/uc/user/userinfo/identityInfoSubmitI", params, {
      des: "直客wap提交账户资料信息",
      sTime: new Date().getTime()
    });
  },
  //认证状态接口
  async getIdentityState(params) {
    return await axios.get("/uc/user/userinfo/identityState", params, {
      des: "直客wap获取账户认证状态",
      sTime: new Date().getTime()
    });
  },
  //获取资金信息
  async getAccoutMarginFree(params = {}) {
    // return new Promise((res, rej) => {
    //   res({
    //     data: {
    //       Status: "0",
    //       IsSuccess: true,
    //       Data: {
    //         accMarginFree: {
    //           leverage: 100,
    //           margin: 0,
    //           balance: 4500,
    //           login: 30233083,
    //           marginfree: 4500,
    //           equity: 4500,
    //           marginFree: 4500.0,
    //           group: "JF1SINDEX_F20"
    //         }
    //       },
    //       Token: ""
    //     }
    //   });
    // });

    return await axios.post("/uc/getAccoutMarginFree", params, {
      des: "直客wap获取资金信息",
      sTime: new Date().getTime()
    });
  },
  //激活模拟账号
  async getSimulationAccount(params = {}) {
    return await axios.post("/uc/user/bindAccount/activateSimulation", params, {
      des: "直客wap激活模拟账号",
      sTime: new Date().getTime()
    });
  }
};

export default accountInfo;



// WEBPACK FOOTER //
// ./src/api/account-info.js